<template>
    <section>
    <CampaignLocationDetailsModal
        :location="locationDetails"
    ></CampaignLocationDetailsModal>
    <Header 
        :header_page_data="headerPageData"
    ></Header>
      <section>
        <div class="container container-app">
            <section class="position-relative campaigns-container mt-4">
                 <div class="col-12 mb-3 pr-0 pl-0">
                    <div class="input-group">
                        <input @input="clearOnEmpty()" @keyup.enter="searchLocations()" :placeholder="$t('campaign_locations.search')" type="text" class="form-control--canvassing border-bottom cancassing-search" v-model="search">
                        <span class="cursor-pointer" @click.prevent="searchLocations()"><img class="search-icon-grey" src="./../../assets/search_grey.svg" alt="search" /></span>
                    </div>
                </div>
                <div>
                    <div v-for="(location, index) in offlineLocations" class="row mb-2" :key="index">
                        <div class="col-2">
                            <div class="round-person-name" :style="'background: ' + listDesignColor[calculateColorListing(index)].background + ';  border: 2px solid #ffffff; border: 2px solid #ffffff; box-shadow: 0 0 0 2px ' + listDesignColor[calculateColorListing(index)].border + ';'"><span :style="'color: ' + listDesignColor[calculateColorListing(index)].color + ';'">{{ location.name.substring(0,1).toUpperCase() }}</span></div>
                        </div>
                        <div class="col-4 mt-3 pl-0">
                            <div @click.prevent="showLocationDetailsOffline(location)" class="person-name ml-3 float-left cursor-pointer">{{ trimText(location.name, 30) }}</div>
                        </div>
                        <div class="col-6 mt-3">
                            <span v-if="typeof location.status != 'undefined' && location.status == 'error'" class="offline-status-error">
                                {{ $t('campaign_locations.needs_your_atttention') }}
                            </span>
                            <span v-else class="offline-status">
                                {{ $t('campaign_locations.pending') }}
                            </span>
                            <div v-if="typeof location.status != 'undefined' && location.status != 'error'">
                                <img v-if="$store.getters['online']" class="location-offline-icon" src="./../../assets/processing_black.svg"/>
                                <img v-else class="location-offline-icon" src="./../../assets/offline_black.svg"/>
                            </div>
                            <!-- <img @click.prevent="showLocationDetailsOffline(location)" class="float-right info-icon mr-3 cursor-pointer" src="./../../assets/info.svg" alt="info" /> -->
                        </div>
                    </div>
                </div>
                <div v-if="this.$store.getters['online']" class="locations-scroll-container">
                    <span class="no-results-found-label" v-if="locations.length == 0 && this.$store.getters['online']">{{ $t('campaign_locations.no_results_found') }}</span>
                    <div v-for="(location, index) in locations" class="row mb-2" :key="index">
                        <div class="col-2">
                            <div class="round-person-name" :style="'background: ' + listDesignColor[calculateColorListing(index)].background + ';  border: 2px solid #ffffff; border: 2px solid #ffffff; box-shadow: 0 0 0 2px ' + listDesignColor[calculateColorListing(index)].border + ';'"><span :style="'color: ' + listDesignColor[calculateColorListing(index)].color + ';'">{{ location.name.substring(0,1).toUpperCase() }}</span></div>
                        </div>
                        <div class="col-5 mt-3 pl-0">
                            <div @click.prevent="showLocationDetails(location)" class="person-name ml-3 float-left cursor-pointer">{{ trimText(location.name, 30) }}</div>
                        </div>
                        <div class="col-5 mt-3">
                            <!-- <img @click.prevent="showLocationDetails(location)" class="float-right info-icon mr-3 cursor-pointer" src="./../../assets/info.svg" alt="info" /> -->
                        </div>
                    </div>
                </div>
            </section>
            <div class="add-persons">
                <img @click.prevent="addLocation()" src="./../../assets/add.svg" alt="add">
            </div>
        </div>
      </section>
    <CampaignFooter></CampaignFooter>
    </section>
</template>

<script>
    import Header from "../layouts/Header";
    import CampaignFooter from "../layouts/CampaignFooter";
    import HelperMixin from "../../mixins/HelperMixin";
    import CampaignLocationDetailsModal from "../modals/CampaignLocationDetailsModal";

    export default {
        name: "CampaignLocations",
        components: {Header, CampaignFooter, CampaignLocationDetailsModal},
        mixins: [HelperMixin],
        data() {
            return {
                stopLoad: false,
                search: null,
                page: 1,
                locationDetails: {
                    name: '',
                    created_by: {
                        name: ''
                    }
                },
                locations: [],
                headerPageData: {
                    title: this.$store.getters["currentCampaign"].name,
                    search: {
                        show: true,
                        type_search: 'locations'
                    },
                    settings: {
                        show: true,
                        campaign: this.$store.getters["currentCampaign"]
                    },
                    home: {
                        show: true,
                        goto: 'campaign-map'
                    },
                    profile: {
                        show: false
                    }
                }
            }
        },
        created() {
            this.page = 1;
            this.refreshCampaignLocations();
            this.getCampaignLocations(this.page, this.search);
            let _this = this;
            this.$root.$on('get-campaign-locations', function () {
                _this.getCampaignLocations(_this.page, _this.search); 
            });
        },
        mounted() {
            let _this = this;
            $('.locations-scroll-container').scroll(function() {
                if (_this.stopLoad != true) {
                    let div = $(this).get(0);
                    if(div.scrollTop + div.clientHeight >= div.scrollHeight) {
                        _this.getCampaignLocations(_this.page, _this.search);
                    }
                }
                
            });
        },
        computed: {
            offlineLocations() {
                let allResponses =  this.$store.getters["offlineLocations"];
                var campaignResponses = [];
                for (var i = 0; i < allResponses.length; i++) {
                    if (allResponses[i].offline_campaign_id == this.$route.params.campaign_id) {
                        campaignResponses.push(allResponses[i]);
                    }
                }
                return campaignResponses;
            },
        },
        methods: {
            addLocation() {
                this.goto('add-location', {campaign_id: this.$store.getters["currentCampaign"]._id});
            },

            clearOnEmpty() {
                if (this.search == '') {
                    if (!this.$store.getters['online']) {
                        return false;
                    }
                    this.locations = [];
                    this.page = 1;
                    this.stopLoad = false;
                    this.getCampaignLocations(this.page, this.search);
                }
            },

            searchLocations() {
                if (!this.$store.getters['online']) {
                    $('#featureUnavailableOfflineModal').modal('show');
                    this.searchText = '';
                    return false;
                }
                this.locations = [];
                this.page = 1;
                this.stopLoad = false;
                this.getCampaignLocations(this.page, this.search);
            },

            refreshCampaignLocations() {
                if (this.$store.getters["user"] === null) {
                    if (typeof this.$store.getters["token"] == 'undefined') {
                         this.$router.replace({ name: "login"});
                    }
                    this.refreshData();
                }
            },

            getCampaignLocations(page = 1, search = null) {
                 this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                let sendData = {
                    page: page
                }
                if (search) {
                    sendData.search = search;
                }
                axios.post(
                        '/api/v1/campaign/' + this.$route.params.campaign_id + '/respondent/get',
                        sendData,
                        config
                ).then(this.consumegetCampaignLocations, this.errorgetCampaignLocations);
                
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },

            consumegetCampaignLocations: function (response) {
                if (response.data.data.last_page >= this.page) {                
                    for (var i = 0; i < response.data.data.data.length; i++) {
                        this.locations.push(response.data.data.data[i]);
                    }
                }
                this.page = this.page + 1;
                if (this.page > response.data.data.last_page) {
                    this.stopLoad = true;
                }
                
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },

            errorgetCampaignLocations: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                console.log(error);
            },

            showLocationDetails(location) {
                let _this = this;
                this.$store.dispatch('saveCurrentRespondent', {
                    currentRespondent: location
                }).then(()=> {
                    if (location.created_by.id == _this.$store.getters["user"]._id || _this.$store.getters["currentCampaign"].owner_id == _this.$store.getters["user"]._id) {
                        _this.goto('edit-location', {campaign_id: _this.$store.getters["currentCampaign"]._id, location_id: location.location_id , respondent_id: location._id});
                    } else {
                        _this.locationDetails = location;
                        $('#campaignLocationDetailsModal').modal('show');
                    }
                });
            },

            showLocationDetailsOffline(location) {
                let _this = this;
                this.$store.dispatch('saveCurrentRespondentOffline', {
                    currentRespondentOffline: location
                }).then(()=> {
                    if (location.created_by.id == _this.$store.getters["user"]._id || _this.$store.getters["currentCampaign"].owner_id == _this.$store.getters["user"]._id) {
                        _this.goto('edit-location-offline', {campaign_id: _this.$store.getters["currentCampaign"]._id});
                    } else {
                        _this.locationDetails = location;
                        $('#campaignLocationDetailsModal').modal('show');
                    }
                });
            },
        },
    };
</script>
